<template>
<div class="col-sm-8 col-sm-offset-2">
  <div class="card float-e-margins">
    <div v-if="loaded" class="card-title text-center">
        <h1>Betaalpagina</h1>
        <h2>order {{order.Id}}</h2>
        <h4>Prijs: <strong>{{order.Total | currencyDisplay}}</strong> <a @click="show = true" style="cursor:pointer" >(klik hier voor overzicht)</a></h4>
    </div>
    <div class="card-content">
      <div class="row" v-if="!loaded">
        <div class="col-xs-2 col-xs-offset-5">
          <img v-else class="img-responsive" src="../../assets/img/ajax_loader.gif" style="max-height:50px;">
          <div class="pull-left">
            <p>Laden..</p>
          </div>
        </div>
      </div>
      <form v-if="loaded" v-on:submit.prevent="checkout()">
        <div class="form-group">
          <label for="email">e-mailadres:</label>
          <p id="email">{{order.CustomerMail}}</p>
        </div>
        <hr>
        <div class="content">
          <label for="paypal">Kies uw betaalmethode:</label>
          <div class="row">
            <div class="col-sm-6">
              <div class="box payment-method">
                <h4 id="paypal">Paypal</h4>
                <div class="col-sm-1">
                  <input type="radio" name="payment" value="paypal/direct" v-model="paymentmethod" @click="setIdeal(false)" required>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="box payment-method">
                <h4>iDeal</h4>
                <div class="col-sm-1">
                  <input type="radio" name="payment" @click="setIdeal(true)">
                </div>
                <div class="col-sm-11">
                  <select class="form-control" v-model="paymentmethod" :disabled="!IdealChecked" :required="IdealChecked">
                    <option disabled selected value></option>
                    <option value="ideal/RABONL2U">Rabobank</option>
                    <option value="ideal/INGBNL2A">ING</option>
                    <option value="ideal/ABNANL2A">ABN AMRO</option>
                    <option value="ideal/SNSBNL2A">SNS Bnk</option>
                    <option value="ideal/RBRBNL21">RegiBank</option>
                    <option value="ideal/ASNBNL21">ASN Bank</option>
                    <option value="ideal/KNABNL2H">Knab</option>
                    <option value="ideal/TRIONL2U">Triodos Bank</option>
                    <option value="ideal/FVLBNL22">van Lanschot</option>
                  </select>
                </div>
              </div>
            </div>            
          </div>
        </div>
        <div class="row">
          <div class="form-group text-right">
            <div class="col-md-12">
              <button type="submit" class="btn btn-success" :disabled="submited" style="margin-top: 15px;">Betalen</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<v-modal :show.sync="show" effect="zoom">
  <div slot="modal-header" class="modal-header">
    <button type="button" class="btn btn-danger pull-right" @click="show=false">
      &times;
    </button>
  </div>
  <div slot="modal-body" class="modal-body">
    <overzicht :products="order.Products" :subtotal.sync="order.SubTotal" :shippingcost.sync="order.ShipCosts" :totalprice="order.Total"></overzicht>
  </div>
  <div slot="modal-footer" class="modal-footer" style="display: none;">
  </div>
</v-modal>
</template>
<script>
import store from '../../store'
import modal from '../Common/Modal'
import overzicht from './betalen-cart'
export default {
  created () {
    var self = this
    $.ajax({
      type: 'GET',
      url: store.root + 'api/Invoices/' + self.$route.params.burl,
      dataType: 'json',
      xhrFields: {
        withCredentials: true
      }
    }).done(function (response) {
      self.order = response
      self.loaded = true
    }).fail(function () {
      self.$route.router.go('/')
    })
  },
  components: {
    store: store,
    'v-modal': modal,
    overzicht
  },
  data () {
    return {
      order: {},
      paymentmethod: '',
      IdealChecked: false,
      loaded: false,
      submited: false,
      show: false
    }
  },
  methods: {
    setIdeal (bool) {
      this.IdealChecked = bool
      if (this.IdealChecked) {
        this.paymentmethod = ''
      }
    },
    checkout () {
      var self = this
      self.submited = true
      $.ajax({
        type: 'POST',
        url: store.root + 'api/checkout?id=' + self.order.Id + '&paymentmethod=' + self.paymentmethod,
        xhrFields: {
          withCredentials: true
        }
      }).done(function (response) {
        // console.log(response)
        window.location.replace(response.payment_url)
      })
      .fail(function (response) {
        // console.log(response)
        self.error = true
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// betalen.vue?29d24948